<template>
  <div class="welcome-set-banner">
    <p class="welcome-set-banner__title">
      Сложно выбрать?
    </p>
    <img
      :src="image"
      alt=""
      @click="openWelcomeSetPage"
    >
  </div>
</template>

<script>
import { WELCOME_SET_PATH } from '@/config/constants'

export default {
  name: 'WelcomeSetBanner',

  props: {
    place: {
      type: String,
      default: '',
    },

    image: {
      type: String,
      required: true,
    },
  },

  methods: {
    async openWelcomeSetPage () {
      let urlPostfix = ''
      if (this.place) {
        urlPostfix = `?ref=${this.place}`
      }
      location.href = WELCOME_SET_PATH + urlPostfix // Not Vue Router because need to reload page
    },
  },
}
</script>

<style lang="scss">
.welcome-set-banner {
  margin-top: 88px;

  &__title {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 16px;
  }
}
</style>
